/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA ;
 */

import { remToPx } from '@oat-sa-private/ui-core';

/** Minimum block size for vertical-text choices; matches DraggableListButton min-height. */
export const VERTICAL_CHOICE_MIN_BLOCK_SIZE = remToPx(6);

/** Maximum block size for vertical-text choices; matches graphic gap match desktop cap. */
export const VERTICAL_CHOICE_MAX_BLOCK_SIZE = remToPx(20);

/** Remover strip height for vertical-text placed choices. */
export const VERTICAL_CHOICE_REMOVER_SIZE = remToPx(4);

/**
 * Clamps a measured choice dimension to the allowed vertical-text range.
 * @param {number} value
 * @param {number} [min]
 * @param {number} [max]
 * @returns {number|undefined}
 */
export function clampVerticalChoiceDimension(
    value,
    min = VERTICAL_CHOICE_MIN_BLOCK_SIZE,
    max = VERTICAL_CHOICE_MAX_BLOCK_SIZE
) {
    if (!value) {
        return value;
    }
    return Math.min(Math.max(value, min), max);
}

/**
 * Clamps measured width and height for vertical-text choice layouts.
 * @param {number} width
 * @param {number} height
 * @returns {{width: number|undefined, height: number|undefined}}
 */
export function clampVerticalChoiceDimensions(width, height) {
    return {
        width: clampVerticalChoiceDimension(width),
        height: clampVerticalChoiceDimension(height)
    };
}
